export default {
      id: "arrow-up-usage",
      viewBox: "0 0 14 14",
      url: "static/docker-35e621d613051bbda5b8b67fc5bb152e/images/" + "sprite.svg#arrow-up-usage",
      toString: function () {
        return this.url;
      }
    }